(() => {
  const expectedCopy = 'Choose any add-on and save 10%';

  const updateCopy = (root = document) => {
    root.querySelectorAll('.lb-bundle-subTitle').forEach((element) => {
      const currentCopy = element.textContent.trim();
      if (
        currentCopy.startsWith('Choose any add-on and save') &&
        currentCopy !== expectedCopy
      ) {
        element.textContent = expectedCopy;
      }
    });
  };

  const observer = new MutationObserver(() => updateCopy());
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateCopy(), { once: true });
  } else {
    updateCopy();
  }
})();
